import { render } from "./SnapshotMessage.vue?vue&type=template&id=452ecfb3"
import script from "./SnapshotMessage.vue?vue&type=script&lang=js"
export * from "./SnapshotMessage.vue?vue&type=script&lang=js"

import "./SnapshotMessage.vue?vue&type=style&index=0&id=452ecfb3&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__